import { useCallback, useMemo, useState } from "react";

import { useAgencyNotices } from "../../contexts/agency-notices.context";
import { agencyNoticesHelper } from "../../helpers/agency-notices.helper";

export const useAgencyNoticesOrchestratorViewModel = () => {
  const {
    agencyNotices,
    closeAgencyNoticeHeaderBanner,
    isLoadingAgencyNotices,
    isAgencyNoticeHeaderBannerVisible,
  } = useAgencyNotices();

  const [seenAgencyNoticeTokens, setSeenAgencyNoticeTokens] = useState(
    agencyNoticesHelper.getSeenAgencyNoticeTokens(),
  );

  const handleCloseAgencyNoticeHeaderBanner = useCallback(() => {
    closeAgencyNoticeHeaderBanner();
  }, [closeAgencyNoticeHeaderBanner]);

  const handleDismissAgencyNoticeHeaderBanner = useCallback((token: string) => {
    agencyNoticesHelper.markAgencyNoticeTokenAsSeen(token);

    setSeenAgencyNoticeTokens((prev) => [...prev, token]);
  }, []);

  const headerBannerAgencyNotice = useMemo(() => {
    if (!agencyNotices) {
      return null;
    }

    const unseenAgencyNotices = agencyNotices.filter(
      (an) => !seenAgencyNoticeTokens.includes(an.token),
    );

    return agencyNoticesHelper.findBestHeaderBannerAgencyNotice(
      unseenAgencyNotices,
    );
  }, [agencyNotices, seenAgencyNoticeTokens]);

  const shouldShowLoading = useMemo(() => {
    return !agencyNotices && isLoadingAgencyNotices;
  }, [agencyNotices, isLoadingAgencyNotices]);

  return {
    handleCloseAgencyNoticeHeaderBanner,
    handleDismissAgencyNoticeHeaderBanner,
    headerBannerAgencyNotice,
    isAgencyNoticeHeaderBannerVisible,
    seenAgencyNoticeTokens,
    shouldShowLoading,
  };
};
